<template>
  <modal v-if="data != null" :visible='visible' 
    @close="close">
    <div class="content content-y">
          <span class="exit" @click="close"><span class="close absolute"> </span></span>
          <div class="columns body is-multiline">
            <div class="column slides is-7-desktop is-12-tablet"> 
              <slides ref="slides" class="media" :media='data.media'/>
            </div>
            <div class="column is-5-desktop is-12-tablet"> 
              <div class="flex justify content-small-y">
                <div class="title"> {{data.title}}</div>
                <div class="text-left body-content">  
                  <div class="description"> 
                    <vue-markdown class="markdown force" v-if="data.body != null" :source='markdown'> {{markdown}} </vue-markdown>   
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
  </modal>
  
</template>

<script>
import modal from '@/components/structure/Modal.vue'
import slides from '@/components/structure/Slides.vue'
import VueMarkdown from 'vue-markdown'

export default {
  name: 'ProjectModal',
  props: {
    data: Object
  },
  components: {
    modal,
    slides,
    VueMarkdown
  },
  data() {
    return {
      visible: false,
      markdown: null
    }
  },
  watch: {
    data(a){
      if(a != null){
        this.visible=true
        this.markdown = this.data.body
      }
    },
  },
  methods: {
    open() {
      this.visible = true;
      this.$refs['slides'].start();
    },
    close(){
      this.visible = false;
      this.$refs['slides'].stop();
    }
  }

}
</script>

<style scoped>

.media{
  width: 100%;
}

.media{
  border-width: 0px;
}


.content{
  color: white;
  min-width: 50%;
  z-index: 20;
  background-color: var(--dark-color);
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.exit{
  cursor: pointer;
  position: absolute;
  right: 0px;
  width: 30px;
  height: 30px;
  opacity: 0.9;
  background-color: var(--bright-color);
  border-radius: 50%;
  z-index: 10;
}

.close{
  position: absolute;
  right: 0px;
  border-radius: 50%;
  overflow: hidden;
  opacity: 0.5;
  width: 70%;
  height: 70%;
  left: 15%;
  top: 15%;
}
.close::before,
.close::after{
  content: '';
  position: absolute;
  border-width: 3px;
  border-style: solid;
  border-color: black;
  top: 0%;
  left: 0%;
  bottom: 0%;
  right: 0%;
  transform: rotate(45deg) translate(50%,50%) scale(1.1, 1.1);
}
.close::after{
  transform: rotate(45deg) translate(-50%,-50%) scale(1.1,1.1);
}

.body-content{
  overflow: auto;
  flex-grow: 1;
  margin: 1em;
  overflow-y: auto;
  flex-shrink: 10;
}

.body-content *{
  max-height: 1000000000px;
}

.body{
  margin: 0;
  bottom: 0;
  height: 100%;
}

.body *{
  padding: 0;
}

.justify{
  justify-content: flex-end;
  align-items: stretch;
}

.slides{
  padding: 0;
}

@media screen and (min-width:1608px){
  .content{
    width: 50%;
  }
  .content-y, .content-small-y{
    max-height: 50vh;
    height: 50vh;
  }
}

@media screen and (max-width:1607px){
  .content{
    width: 80%;
  }
  .content-y, .content-small-y{
    max-height: 50vh;
    height: 50vh;
  }
}



@media screen and (max-width:1023px){
  .content{
    width: 70%;
  }
  .content-y{
    max-height: 90vh;
    height: 90vh;
  }
  .content-small-y{
    max-height: 60vh;
    height: 60vh;
  }
  .slides {
    height: 30vh;
  }
}

@media screen and (max-width:768px){
  .content{
    width: 90%;
    max-height: 90vh;
    height: 90vh;
  }
  .content-y{
    max-height: 90vh;
    height: 90vh;
  }
  .content-small-y{
    max-height: 60vh;
    height: 60vh;
  }
  .slides {
    height: 30vh;
  }
}


div.title{
  margin: 0.4em;
  color: white;
  font-family: 'OpenSans';
  flex:none;
  font-weight: normal;
  text-align: left;
}

</style>
